import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Layout as DashboardLayout } from 'src/layouts/dashboard';
import CustomersPage from 'src/pages/dashboard/customers/list';
import CustomerProfilePage from 'src/pages/dashboard/customers/[id]';
import { Profile } from 'src/pages/profile/profile';

const IndexPage = lazy(() => import('src/pages/dashboard/index'))
// const CustomerListPage = lazy(() => import('src/pages/dashboard/customers/list'));
const TransactionsListPage = lazy(() => import('src/pages/dashboard/transactions/list'));
const TeamPage = lazy(() => import('src/pages/dashboard/team/teamPage'));
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));
const Status = lazy(() => import('src/pages/dashboard/customDesign/Status'));
const House = lazy(() => import('src/pages/dashboard/customDesign/House'));
const KYB = lazy(() => import('src/pages/dashboard/kyb'));
const Rating = lazy(() => import('src/pages/dashboard/customDesign/Rating'));
const WebHook = lazy(() => import('src/pages/dashboard/setting/WebHook').then(module => ({ default: module.WebHook })));


// const WebHook = lazy(() => import('src/pages/dashboard/setting/WebHook'));





export const dashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />
      },
      {
        path: 'customers',
        children: [
          {
            index: true,
            element: <CustomersPage />
          },
          {
            path: ':id',
            element: <CustomerProfilePage />
          }
        ]
      },
      {
        path: 'transactions',
        children: [
          {
            index: true,
            element: <TransactionsListPage />
          },

        ]
      },
      {
        path: 'teams',
        children: [
          {
            index: true,
            element: <TeamPage />
          },

        ]
      },
      {
        path: 'kyc',
        element:<House />
      },  {
        path: 'kyb',
        element:<KYB />
      },

      {
        path: 'status',
        element:<Status />
      },
      {
        path: 'log',
        element:<House />
      },
      {
        path: 'rating',
        element:<Rating />
      },
      {
        path: 'profile',
        element: <Profile />
      },
      {
        path: 'config',
        element:<House/>
      },
      {
        path: 'api',
        element:<House />
      },
      {
        path: 'webhooks',
        element:<WebHook />
      },
      {
        path: 'blank',
        element: <BlankPage />
      },
    ]
  }
];
